export default __webpack_public_path__ + "static/media/167476.7b9157c3.png";